/**
 * True when the selected exploration account is an org rollup entry.
 *
 * Org aggregates are keyed as `org:{tenantId}` when `isOrganizationView` is true
 * at cache-build time (see `fetchExplorationVolumeCaches`).
 */
export function isExplorationOrgAggregateAccount(accountId: string | null | undefined): boolean {
  return !!accountId?.startsWith('org:');
}
